import moment from 'moment';
import { getMinDate } from './TeilnehmerMelden/teilnahmedatum';

/**
 * Sagt einer Karte in der Veranstaltungsliste, was ihr Datum bedeutet.
 *
 * Bis hierher sah eine Veranstaltung von vorgestern genauso aus wie die, an deren Einlasstisch
 * man gerade steht - unterschieden wurde nur durch das Lesen zweier Datumsangaben in der grauen
 * Zeile.
 *
 * Reine Funktion, wie `meldeversuchHinweis` und `speichermodusHinweis`: die Komponente rendert
 * nur noch, was hier entschieden wird, und die Grenzfaelle sind ohne Rendern pruefbar. `jetzt`
 * ist deshalb ein Parameter - sonst haengt der Test an der Uhr des Rechners.
 *
 * **Gerechnet wird auf Tagesgrenzen, nicht auf Uhrzeiten.** Eine Veranstaltung, die heute um
 * 17:00 endete, ist um 17:30 nicht "vergangen" - da steht man noch am Tisch und erfasst die
 * Schlange. Uhrzeitgenau kippte die Karte mitten in der Arbeit um.
 *
 * `getMinDate` kommt aus `teilnahmedatum.js` und wird nicht nachgebaut: dieselbe Grenze
 * entscheidet auf der Veranstaltungsseite, ob ueberhaupt erfasst werden darf
 * (`isVeranstaltungsBeginnInZukunft`). Mit einer eigenen Rechnung verspraeche "Ab TT.MM." etwas
 * anderes, als die Seite dahinter zulaesst.
 */
const NEUTRAL = "bg-body-secondary text-body";
const OHNE_KENNZEICHEN = { text: null, klasse: null, gedaempft: false };

export const veranstaltungsChip = (veranstaltung, countErfasste = 0, jetzt = moment()) => {
	// Alte Eintraege im Store koennen die Felder nicht haben: lieber nichts sagen als Falsches.
	if(!veranstaltung || !veranstaltung.beginn || !veranstaltung.ende) return OHNE_KENNZEICHEN;
	const heute = moment(jetzt).startOf("day").valueOf();
	const beginn = getMinDate(veranstaltung);
	const ende = moment(veranstaltung.ende).startOf("day").valueOf();

	if(beginn > heute) return {
		text: `Ab ${moment(veranstaltung.beginn).format("DD.MM.")}`, klasse: NEUTRAL, gedaempft: false };
	if(ende >= heute) return {
		text: ende === heute? "Heute" : `Läuft bis ${moment(veranstaltung.ende).format("DD.MM.")}`,
		klasse: NEUTRAL, gedaempft: false };
	// Vergangen, aber es liegt noch etwas darin: die einzige echte Restarbeit in der Liste, und
	// deshalb das einzige Farbige. Gedaempft wird sie nicht - sonst verschwaende genau die Karte,
	// die man nicht uebersehen darf. Bei laufenden Veranstaltungen sind offene Teilnahmen der
	// Normalzustand der Arbeit und bekommen keinen Hinweis.
	if(countErfasste > 0) return {
		text: `${countErfasste} noch zu melden`, klasse: "text-bg-warning", gedaempft: false };
	return { ...OHNE_KENNZEICHEN, gedaempft: true };
};
